module.exports = __webpack_public_path__ + "img/f-en.cfbc40e8.png";